var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3436",
    "data-name": "Grupo 3436",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.667,
    height: 62.757,
    viewBox: "0 0 157.667 62.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2517",
    "data-name": "Ret\\xE2ngulo 2517",
    width: 157.667,
    height: 62.757
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3435",
    "data-name": "Grupo 3435",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2437",
    "data-name": "Caminho 2437",
    d: "M5.653,47.219H0L23.048,78.6,0,109.978H5.653L28.7,78.6Z",
    transform: "translate(0.001 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2438",
    "data-name": "Caminho 2438",
    d: "M10.215,47.219H4.563L27.607,78.6,4.563,109.978h5.652L33.262,78.6Z",
    transform: "translate(9.934 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2439",
    "data-name": "Caminho 2439",
    d: "M14.778,47.219H9.125L32.169,78.6,9.125,109.978h5.652L37.825,78.6Z",
    transform: "translate(19.867 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2440",
    "data-name": "Caminho 2440",
    d: "M19.34,47.219H13.688L36.732,78.6,13.688,109.978H19.34L42.387,78.6Z",
    transform: "translate(29.801 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2441",
    "data-name": "Caminho 2441",
    d: "M23.9,47.219H18.25L41.294,78.6,18.25,109.978H23.9L46.95,78.6Z",
    transform: "translate(39.734 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2442",
    "data-name": "Caminho 2442",
    d: "M27.994,47.219H22.342L45.389,78.6,22.342,109.978h5.652L51.041,78.6Z",
    transform: "translate(48.642 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2443",
    "data-name": "Caminho 2443",
    d: "M32.557,47.219H26.9L49.949,78.6,26.9,109.978h5.652L55.6,78.6Z",
    transform: "translate(58.576 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2444",
    "data-name": "Caminho 2444",
    d: "M37.119,47.219H31.467L54.511,78.6,31.467,109.978h5.652L60.166,78.6Z",
    transform: "translate(68.509 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2445",
    "data-name": "Caminho 2445",
    d: "M41.682,47.219H36.029L59.073,78.6,36.029,109.978h5.652L64.729,78.6Z",
    transform: "translate(78.442 -47.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2446",
    "data-name": "Caminho 2446",
    d: "M46.244,47.219H40.592L63.636,78.6,40.592,109.978h5.652L69.291,78.6Z",
    transform: "translate(88.376 -47.219)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeta);
export default __webpack_public_path__ + "static/media/icon-seta.4e4e3d59d61b06c3bd4f716973006761.svg";
export { ForwardRef as ReactComponent };